import {
	Component,
	Input,
	SimpleChanges,
	ComponentFactoryResolver,
	ViewContainerRef,
	ViewChild,
	Output,
	EventEmitter,
} from "@angular/core";
import { BaseView } from "../base-view";
import { Subscription } from "rxjs";
import { CoursePage } from "../../vo/course-page";
import { UtilityScripts } from "../../../helpers/utility-scripts";
import { Router } from "@angular/router";
import { AppServices } from "app/app.services";
import { PageLoaderService } from "../../../directives/page-loader-animation/page-loader.service";
import { HttpService } from "app/services/http.service";
import { ApplicationModel } from "app/core/models/application.model";
import { OrientationModelService } from "app/core/models/orientation-model.service";
import { ScreenControllerService } from "app/core/controls/screen-controller.service";
import { CourseControllerService } from 'app/core/controls/course-controller.service';
import { KeyPressConstants } from "app/core/vo/app-constants";

@Component({
	selector: "app-rubric-interface",
	templateUrl: "./rubric-interface.component.html",
	styleUrls: ["./rubric-interface.component.css"],
})
export class RubricInterfaceComponent extends BaseView {
	@Input() coursePage: CoursePage;
	@Input() audioOn: boolean;
	@Input() currPresMode: string;
	@Input() currentpage: string;
	@Input() currDocs: any;
	@Input() flagList: any;
	@Input() isContinue: boolean;
	@Input() pauseAudio: boolean;
	@Input() audioStarted: string;
	@Input() audioUpdate: string;
	@Input() audioCompleted: string;

	//@ViewChild('loadRubric', { read: ViewContainerRef }) loadRubric: ViewContainerRef;
	@ViewChild("audioDir") audioDir;
	@ViewChild("autoPlayBtn") autoPlayBtn;

	private rubric;
	private definition: string;
	private isPlayIconDisplayed: Boolean = false;
	private prevRubric: string = "";
	public subscription: Subscription;
	public rubricCompleteSubscription: Subscription;
	public rubricloadCompleteSubscription: Subscription;
	public rubricDisposeSubscription: Subscription;
	public defintionUpdateSubscription: Subscription;
	public jumpToPageSubscription: Subscription;
	public activateButtonsSubscription: Subscription;
	public autoTransitionSubscription: Subscription;
	public appStateSubscription: Subscription;
	public Audiosubscription: Subscription;
	public ccSubscription: Subscription;
	public swfSubscription: Subscription;
	public audioPath: string;
	public showAudio: boolean;
	public showCCText: boolean = false;
	public rubricName: string;
	public ccContent: string = "";
	public audioswf: string;
	private updateTemplateObj:object;
	@Output() rubricComplete: EventEmitter<string> = new EventEmitter<string>();
	@Output() updateDefinition: EventEmitter<string> = new EventEmitter<string>();
	@Output() jumpToPageEvent: EventEmitter<string> = new EventEmitter<string>();
	@Output() templateLoaded: EventEmitter<string> = new EventEmitter<string>();
	@Output() activateButtonEvent: EventEmitter<string> =
		new EventEmitter<string>();
	@Output() autoTransitionEvent: EventEmitter<boolean> =
		new EventEmitter<boolean>();
	//@Output() loadRubricComponent: EventEmitter<string> = new EventEmitter<string>();
	@Output() rubricLoadedEvent: EventEmitter<string> =
		new EventEmitter<string>();
	constructor(
		protected httpService: HttpService,
		private compFactoryResolver: ComponentFactoryResolver,
		private router: Router,
		private appServices: AppServices = null,
		private pageLoaderServices: PageLoaderService = null,
		public orientationModel: OrientationModelService,
		private screenController: ScreenControllerService,
		private courseControllerService: CourseControllerService
	) {
		super();
	}

	public ngOnChanges(changes: SimpleChanges) {
		if (
			changes.hasOwnProperty("coursePage") &&
			changes["coursePage"]["currentValue"] != undefined
		) {
			this.updateScreen();
		}
		if (
			changes.hasOwnProperty("audioOn") &&
			changes["audioOn"]["currentValue"] != undefined
		) {
			this.updateScreenAudio();
		}
		if (
			changes.hasOwnProperty(`currPresMode`) &&
			changes[`currPresMode`][`currentValue`] != undefined
		) {
			if (
				changes[`currPresMode`][`currentValue`] === "medium" &&
				this.isPlayIconDisplayed
			) {
				ApplicationModel.instance.audioModeChangeOverlay = true;
			}
			if (
				changes[`currPresMode`][`currentValue`] === "high" &&
				this.isPlayIconDisplayed
			) {
				ApplicationModel.instance.audioModeChangeOverlay = true;
			}
			this.updateScreen();
		}
		if (
			changes.hasOwnProperty(`isContinue`) &&
			changes[`isContinue`][`currentValue`] != undefined
		) {
			if (changes[`isContinue`][`currentValue`] === true) {
				this.continuePage();
			}
		}
		if (
			changes.hasOwnProperty(`pauseAudio`) &&
			changes[`pauseAudio`][`currentValue`] !== undefined &&
			this.rubric !== undefined
		) {
			this.pauseOrPlayRubricAudio();
		}
		if (
			changes.hasOwnProperty(`audioStarted`) &&
			changes[`audioStarted`][`currentValue`] !== undefined &&
			this.rubric !== undefined
		) {
			this.rubric.instance.audioStartHandler(
				changes[`audioStarted`][`currentValue`]
			);
			//this.audioStarted = false;
		}
		if (
			changes.hasOwnProperty(`audioUpdate`) &&
			changes[`audioUpdate`][`currentValue`] !== undefined &&
			this.rubric !== undefined
		) {
			this.rubric.instance.ontimeupdate(changes[`audioUpdate`][`currentValue`]);
		}
		if (
			changes.hasOwnProperty(`audioCompleted`) &&
			changes[`audioCompleted`][`currentValue`] !== undefined &&
			this.rubric !== undefined
		) {
			this.rubric.instance.audioCompleteHandler(
				changes[`audioCompleted`][`currentValue`]
			);
		}
	}

	toggleTranscriptEvent() {
		ApplicationModel.instance.showTranscript =
			!ApplicationModel.instance.showTranscript;
	}

	public get getTranscriptValue(): boolean {
		return ApplicationModel.instance.showTranscript;
	}

	public get textDirection() {
		return ApplicationModel.instance.flowDirection;
	}
	private updateScreenAudio(): void {
		if (this.rubric) {
			this.rubric.instance.updateAudioStatus(this.audioOn);
		}
	}

	private updateScreen(): void {
		let prevRubricMode = this.currPresMode;
		if (this.rubric) {
			this.destroyPreviousRubric();
		}
		if (!this.coursePage) {
			return;
		}
		this.showAudio = false;
		this.pageLoaderServices.show();

		let classRef = this;
		if (ApplicationModel.instance.presMode.length > 0)
			this.currPresMode = ApplicationModel.instance.presMode;

		this.httpService.get(this.coursePage.page_path).then(
			(res: any) => {
				let xmlData = new DOMParser().parseFromString(res, "text/xml");
				classRef.currPresMode = UtilityScripts.overridePresentationMode(
					xmlData,
					classRef.currPresMode
				);
				if (
					(prevRubricMode !== "medium" && classRef.currPresMode === "medium") ||
					(prevRubricMode !== "high" && classRef.currPresMode === "high")
				) {
					ApplicationModel.instance.audioModeChangeOverlay = true;
				}
				classRef.loadRubric();
			},
			(error: any) => {
				classRef.loadRubric();
			}
		);
	}
	private loadRubric() {
		ApplicationModel.instance.audioOverlayInVideoMode = true;
		ApplicationModel.instance.unmuteAudioOnRubricLoad = true;
		this.ccContent = "";
		//this.audioPath = '';
		this.showCCText = false;
		if (
			!this.showPlayButton() &&
			this.currPresMode === "high" &&
			!this.showAudioModeChangeOverlay()
		) {
			this.audioPath = "";
			this.playAudio();
		}
		if (
			!this.showPlayButton() &&
			this.currPresMode === "medium" &&
			!this.showAudioModeChangeOverlay()
		) {
			this.audioPath = "";
			this.playAudio();
		}

		let classRef = this;
		if (
			this.prevRubric ==
			UtilityScripts.getRubricName(this.coursePage.page_rubric)
		) {
			this.router.navigate(["dummy"], {
				queryParams: {
					pagePath: this.coursePage.page_path,
					audioOn: this.audioOn,
					currPresMode: this.currPresMode,
					currDocs: JSON.stringify(this.currDocs),
					flagList: JSON.stringify(this.flagList),
				},
				skipLocationChange: true,
			});
			setTimeout(function () {
				classRef.router.navigate(
					[UtilityScripts.getRubricName(classRef.coursePage.page_rubric)],
					{
						queryParams: {
							pagePath: classRef.coursePage.page_path,
							audioOn: classRef.audioOn,
							currPresMode: classRef.currPresMode,
							currDocs: JSON.stringify(classRef.currDocs),
							flagList: JSON.stringify(classRef.flagList),
						},
						skipLocationChange: true,
					}
				);
			}, 100);
		} else
			this.router.navigate(
				[UtilityScripts.getRubricName(this.coursePage.page_rubric)],
				{
					queryParams: {
						pagePath: this.coursePage.page_path,
						audioOn: this.audioOn,
						currPresMode: this.currPresMode,
						currDocs: JSON.stringify(this.currDocs),
						flagList: JSON.stringify(this.flagList),
					},
					skipLocationChange: true,
				}
			);

		console.log("UtilityScripts.getRubricName(this.coursePage.page_rubric)", UtilityScripts.getRubricName(this.coursePage.page_rubric))

		this.prevRubric = UtilityScripts.getRubricName(this.coursePage.page_rubric);
		//const rubricComponent: any = this.rubricFactoryService.getRubric(this.coursePage.page_rubric);
		console.log('this.prevRubric', this.prevRubric)

		//this.loadRubricComponent.emit(UtilityScripts.getRubricName(this.coursePage.page_rubric));
		//if (rubricComponent) {
		this.templateLoaded.emit("");
		if(this.defintionUpdateSubscription){
			this.defintionUpdateSubscription.unsubscribe();
		}
		this.rubricCompleteSubscription =
			this.appServices.rubricComplete$.subscribe((event) =>
				this.rubricCompleted(event)
			);
		this.defintionUpdateSubscription =
			this.appServices.updateDefinition$.subscribe((event) =>
				this.definitionUpdated(event)
			);
		this.jumpToPageSubscription = this.appServices.jumpToPage$.subscribe(
			(event) => this.jumpToPageFired(event)
		);
		this.subscription = this.appServices.toInterface$.subscribe((event) =>
			this.receivedFromRubric(event)
		);
		this.activateButtonsSubscription =
			this.appServices.activateButtons$.subscribe((event) =>
				this.activateButtonsFired(event)
				);
		this.autoTransitionSubscription =
			this.appServices.autoTransition$.subscribe((event) =>
				this.triggerAutoTransition(event)
			);
		this.Audiosubscription = this.appServices.audioEvent$.subscribe((event) =>
			this.audiopathFromRubric(event)
		);
		this.ccSubscription = this.appServices.audioCCText$.subscribe((event) =>
			this.audioCcFromRubric(event)
		);
		this.swfSubscription = this.appServices.swfText$.subscribe((event) =>
			this.swfFromRubric(event)
		);
		this.rubricloadCompleteSubscription =
			this.appServices.rubricLoaded$.subscribe((event) =>
				this.rubricLoaded(event)
			);
		if (!this.appStateSubscription) {
			this.appStateSubscription = this.appServices.appStateEvent$.subscribe(
				(event) => {
					if (event) {
						this.applicationStateChanged(event);
					}
				}
			);
		}
		this.rubricDisposeSubscription =
			this.appServices.rubricDisposeEvent$.subscribe((event) => {
				if (event) {
					this.rubricDisposeHandler(event);
				}
			});
		this.rubric = this.coursePage.page_rubric; //this.loadRubric.createComponent(rubricComponent);

		window.scrollTo(0, 0);
		/*if (!this.showPlayButton() && this.currPresMode !== 'low'  ) // autoplay button is not visible then only needs to  autoplay 
    {
       this.playAudio();
    }*/
	}
	public updateRubricViewed(templateName: string) {
		this.courseControllerService.updateRubricViewedStatus(templateName)
	  }
	public continuePage() {
		this.rubric.instance.navigateToRubric();
	}
	public pauseOrPlayRubricAudio() {
		//this.rubric.instance.pauseAudio = this.pauseAudio;
		this.appServices.rubricStateUpdate({
			state: this.pauseAudio ? "pause" : "resume",
		});
	}
	private definitionUpdated(evt: string) {
		this.updateDefinition.emit(evt);
	}
	private audiopathFromRubric(evt: any) {
		this.showAudio = false;
		this.audioPath = "";
		if (evt != undefined && evt != "" && evt != null) {
			this.showAudio = true;
			this.audioPath = evt;
		}
		if (
			!this.showPlayButton() &&
			this.currPresMode !== "low" &&
			!this.showAudioModeChangeOverlay()
		) {
			// autoplay button is not visible then only needs to autoplay
			this.playAudio();
		}
		//this.audioEvent.emit(evt);
		//this.audioFilename.emit(evt);
	}
	private swfFromRubric(evt: any) {
		console.log("swf", evt);
		this.audioswf = evt;
	}
	private audioCcFromRubric(evt: any) {
		this.showCCText = false;
		this.ccContent = "";
		if (this.currPresMode == "medium") {
			if (
				evt != undefined &&
				evt != "" &&
				evt != null &&
				(this.prevRubric == "videobric4" ||
					this.prevRubric == "videobric_adaptive")
			) {
				this.showCCText = true;
				this.ccContent = evt;
			}
		}
	}
	private rubricLoaded(event: string) {
		this.rubricloadCompleteSubscription.unsubscribe();
		this.pageLoaderServices.hide();
		this.rubricLoadedEvent.emit(event);
		//this.updateTemplateViewed(UtilityScripts.getRubricName(this.coursePage.page_rubric))
	}
	private rubricCompleted(event: string) {
		this.updateRubricViewed(UtilityScripts.getRubricName(this.coursePage.page_rubric))
		this.rubricComplete.emit(event);
		if (ApplicationModel.instance.isAdaptivePlayer)
			this.screenController.courseContextModel.updateCompletedPagesInCourse();
	}
	private rubricDisposeHandler(event: any) {
		this.audioPath = "assets/audio/noaudio.mp3";
		this.showAudio = false;
		this.pauseAudio = true;
		if (this.audioDir && event.mode !== "low") {
			this.audioDir.stopAudio();
		}
	}
	private jumpToPageFired(event: string) {
		this.jumpToPageSubscription.unsubscribe();
		this.jumpToPageEvent.emit(event);
	}
	private receivedFromRubric(event: any) {}
	private activateButtonsFired(event: string) {
		this.activateButtonsSubscription.unsubscribe();
		this.activateButtonEvent.emit(event);
	}
	private triggerAutoTransition(event: any) {
		this.autoTransitionSubscription.unsubscribe();
		this.autoTransitionEvent.emit(event);
	}
	private applicationStateChanged(event: any) {
		this.appStateSubscription.unsubscribe();
		this.isPlayIconDisplayed = false;
		this.pauseAudio = true;
		this.updateScreen();
	}
	public destroyPreviousRubric() {
		if (this.rubric) {
			if (this.subscription) {
				this.subscription.unsubscribe();
				this.subscription = null;
			}
			if (this.defintionUpdateSubscription) {
				this.defintionUpdateSubscription.unsubscribe();
				this.defintionUpdateSubscription = null;
			}
			if (this.rubricCompleteSubscription) {
				this.rubricCompleteSubscription.unsubscribe();
				this.rubricCompleteSubscription = null;
			}
			this.rubric = ""; //.destroy();
		}
	}
	public audioCompleteHandler(event) {
		// this.rubric.instance.audioCompleteHandler(event);
		this.appServices.audioCompleteHandler(event);
	}
	public audioStartHandler(event) {
		// this.rubric.instance.audioStartHandler(event);
		this.appServices.audioStartHandler(event);
	}
	public audioUpdateHandler(time) {
		// this.rubric.instance.ontimeupdate(time);
		this.appServices.onTimeUpdate(time);
	}
	public onNextButtonClick(event) {
		alert("nexttttttttttttttttttttttt");
	}
	public onKeyDownClick(event) {
		if (event.code == KeyPressConstants.TAB) {
			event.preventDefault();
		}
	}
	public playAudioBtnClickHandler() {
		if (!this.isPlayIconDisplayed) {
			this.playAudio();
			this.isPlayIconDisplayed = true;
		}
	}
	private playAudio() {
		if (
			this.audioPath === undefined ||
			this.audioPath === "" ||
			this.audioPath == "assets/audio/noaudio.mp3"
		) {
			this.audioPath = "assets/audio/blank.mp3";
			this.showAudio = false;
		}
		this.pauseAudio = false;		
		
		if (this.audioDir) { this.audioDir.playAudio(); }
		if (this.autoPlayBtn) {
			this.autoPlayBtn.nativeElement.style.display = "none";
		}		
	}

	private showPlayButton() {
		if (!this.coursePage) {
			return false;
		}
		if (this.currPresMode && this.currPresMode === "low") {
			return false;
		}
		// if ( this.currentpage && parseInt(this.currentpage, 0) > 0 ) {return false; }
		if (this.isPlayIconDisplayed) {
			return false;
		}
		if(!ApplicationModel.instance.videoOverlay){
			return false;
		}
		if (this.audioPath == "assets/audio/noaudio.mp3") {
			return false;
		}
		this.rubricName = UtilityScripts.getRubricName(this.coursePage.page_rubric);
		if (
			this.rubricName.indexOf("videobric") !== -1 &&
			this.currPresMode === "high"
		) {
			//video mode no autoplay button
			//this.isPlayIconDisplayed = true;
			return false;
		} else {
			if (!ApplicationModel.instance.audioOverlayInVideoMode) {
				return false;
			}
			this.pauseAudio = true;
			return true;
		}
	}

	private showAudioModeChangeOverlay() {
		if (
			/iPhone|ipad/i.test(navigator.userAgent) &&
			ApplicationModel.instance.audioModeChangeOverlay
		) {
			this.isPlayIconDisplayed = false;
			this.pauseAudio = true;
			ApplicationModel.instance.audioModeChangeOverlay = false;
			return true;
		} else return false;
	}

	public get isSrubberEnabled(): boolean {
		return (
			this.screenController.pageComplete &&
			(this.prevRubric === "videobric4" ||
				this.prevRubric === "videobric_adaptive")
		);
	}

	public get language() {
		return this.screenController.courseContextModel.currentLanguage;
	}
}
